import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  richText: {
    '& p': {
      margin: '0 0 1rem',
      fontSize: '1.2rem',
    },
    '& h1, h2, h3, h4, h5, h6, ul, ol': {
      margin: '2rem 0  1rem',
    },
    '& h4': {
      fontWeight: 300,
      fontSize: 24,
    },
    '& h5': {
      fontWeight: 300,
      fontSize: 20,
    },
    '& a': {
      color: styles.palette.text.secondary,
      textDecoration: 'none',
      transition: styles.transitions.regular(['color']),
      '&:visited': {
        color: styles.palette.text.secondary,
      },
      '&:hover': {
        color: styles.palette.text.secondaryDark,
      },
      '&:active, &:focus': {
        color: styles.palette.text.secondaryIntensive,
      },
    },
    '& ul, & ol': {
      margin: '0 0 1rem',
      paddingInlineStart: '2em',
      fontSize: '1.2rem',
    },
    '& li': {
      marginBottom: '0.5rem',
    },
    '& ul li::marker': {
      color: styles.palette.text.secondary,
    },
    '& strong': {
      fontWeight: 400,
    },
  },
});
